import "antd/dist/reset.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Store } from "./Store/Store";
import { Provider } from "react-redux";

// window.onerror = () => true;
// window.onunhandledrejection = () => true;


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={Store}>
    <App />
  </Provider>
);

if (process.env.NODE_ENV === 'production') {
      console.log = function() {};
      console.info = function() {};
      console.warn = function() {};
    }



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
